// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Terms_container__H-1KM{
    margin: 50px 20px;
}
.Terms_subheader__oD-5c{
    margin-bottom: 10px;
    font-weight: 700;
}
.Terms_paragraph__44eAm{
    margin-bottom: 10px;
}
.Terms_italicParagraph__hu-kl{
    margin-bottom: 10px;
    font-style: italic;
}
.Terms_border__U0AaT{
    width: 200px;
    margin-top: 15px;
    margin-bottom: 30px;
    border-top: 3px solid black;
}`, "",{"version":3,"sources":["webpack://./src/pages/Terms.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;AAC/B","sourcesContent":[".container{\n    margin: 50px 20px;\n}\n.subheader{\n    margin-bottom: 10px;\n    font-weight: 700;\n}\n.paragraph{\n    margin-bottom: 10px;\n}\n.italicParagraph{\n    margin-bottom: 10px;\n    font-style: italic;\n}\n.border{\n    width: 200px;\n    margin-top: 15px;\n    margin-bottom: 30px;\n    border-top: 3px solid black;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Terms_container__H-1KM`,
	"subheader": `Terms_subheader__oD-5c`,
	"paragraph": `Terms_paragraph__44eAm`,
	"italicParagraph": `Terms_italicParagraph__hu-kl`,
	"border": `Terms_border__U0AaT`
};
export default ___CSS_LOADER_EXPORT___;
